export default function Logo({ className }: { className?: string }) {
  return <img src="/woc.webp" alt="logo" className={className} />;
}
